import ApplicationsList from './applicationsList'

export default ApplicationsList